let config;

config = {
   // api_url: "https://localhost:7043/api/v1/",
    api_url: "https://dc-prd-cct-api.dcc8fc7.eas.morningstar.com/api/v1/",
    audioFileType:".mp3,.mp4",
    pptFileType:".pdf,.ppt",
    transcriptFileType:".pdf,.doc,.docx",
    alertTime:5, // seconds
    ffPriorityList: "FF1,FF2,FF3" ,
      earningsValues: ['12', '13', '14', '15'],
      nonEarningsValues: ['5', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29'],
      allDefaultValues: ['12','13','14','15','5','16','17','18','19','20','21','22','23','24','25','26','27','28','29'],
      defaultDataSet: [
        { text: 'Select All', value: '__SELECT_ALL__' },
        { text: '• <strong>Earnings</strong>', value: '__EARNINGS_PARENT__' },
        { text: 'First Quarter Earnings Conference Call', value: '12' },
        { text: 'Second Quarter Earnings Conference Call', value: '13' },
        { text: 'Third Quarter Earnings Conference Call', value: '14' },
        { text: 'Fourth Quarter Earnings Conference Call', value: '15' },
        { text: '• <strong>Non-Earnings</strong>', value: '__NON_EARNINGS_PARENT__' },
        { text: 'Brokers/Investment bank Call', value: '5' },
        { text: 'Sales Call', value: '16' },
        { text: 'Analyst/Investor Day or meet', value: '17' },
        { text: 'Strategic/Management update Call', value: '18' },
        { text: 'M&A/Spin-off Call', value: '19' },
        { text: 'Q1 Guidance Call', value: '20' },
        { text: 'Q2 Guidance Call', value: '21' },
        { text: 'Q3 Guidance Call', value: '22' },
        { text: 'Q4 Guidance Call', value: '23' },
        { text: 'Other Guidance Call', value: '24' },
        { text: 'Fireside chats', value: '25' },
        { text: 'Roadshow Calls', value: '26' },
        { text: 'Capital Markets Day', value: '27' },
        { text: 'Other Conference call', value: '28' },
        { text: 'Annual General Meeting', value: '29' }
      ],
  };

  export default config;